import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { gsap } from "gsap";
import useScript from "../../hooks/useScript";
import Footer from "../../components/Footer";
import checkIcon from "../../assets/check.png";
import backArrowIcon from "../../assets/img/left.png";
import { RichText } from "prismic-reactjs";
import { createGlobalStyle } from "styled-components";

import "./index.scss";
import MainLogos from "../../components/MainLogos";
import SEO from "../../components/SEO";
import DisquairePage from "./DisquairePage";
import { hexToRgb } from "../../utils";

const ArtistPage = ({ artistsData, globalData, index, document }) => {
  const navigate = useNavigate();
  const [pageData] = useState(artistsData[index]);
  const [isSubscribed, setIsSubscribed] = useState(false);

  const mainRef = useRef(null);
  const backHomeRef = useRef(null);
  const contentContainerRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const status = useScript(
    "https://wct.live/app/sdk/v2/platform.js?campaign=" + pageData.id_wmg
  );

  useEffect(() => {
    if (status === "ready" && pageData.id_wmg) {
      const connect_button = new window.WMGConnect(".wmg-button", {
        opt_in_form_target: "#formulaire",
        opt_in_thank_you_enabled: false,
      });

      connect_button.setCallback(function (connect_data) {
        setIsSubscribed(true);
        window.scrollTo(0, 0);
      });
    }
  }, [status]);

  useEffect(() => {
    window.location = "https://www.wmplay.fr/disquaireday";
    if (pageData) {
      // if (
      //   new Date() < new Date(pageData.startingdate) &&
      //   pageData.debugmode === false
      // ) {
      //   navigate("/");
      // }

      window.digitalData.page.pageInfo.pageName =
        "WMF Concours:Warner Noel 2024 Advent Sweeps:Landing:" +
        pageData.genrename[0].text;
      window.digitalData.page.category.primaryCategory =
        "WMF Concours:Artist Page";
      window.digitalData.page.category.pageType =
        "artist page:" + pageData.genrename[0].text;

      window.document.dispatchEvent(new CustomEvent("SPAPageTriggered"));
    }
  }, [pageData]);

  useEffect(() => {
    // if (mainRef.current) {
    //   gsap.from(mainRef.current, {
    //     opacity: 0,
    //     y: 50,
    //     duration: 1,
    //     ease: "power3.out",
    //   });
    // }

    if (backHomeRef.current) {
      gsap.from(backHomeRef.current, {
        opacity: 0,
        x: -50,
        duration: 1,
        delay: 0.5,
        ease: "power3.out",
      });
    }

    if (contentContainerRef.current) {
      gsap.from(contentContainerRef.current, {
        opacity: 0,
        y: 50,
        duration: 1,
        delay: 0.8,
        ease: "power3.out",
      });
    }
  }, []);

  if (pageData && globalData) {
    const GlobalStyles = createGlobalStyle`
      :root {
        --color--main: ${globalData.maintextcolor};
        --color-bg: ${globalData.backgroundcolor};
        --color-bg-element: ${globalData.elementbackgroundcolor};
        --color-accent: ${globalData.ctacolor};
        }
    `;

    return (
      <>
        <GlobalStyles />
        <main
          style={{
            color: globalData.maintextcolor,
          }}
          ref={mainRef}
          className="artistPage"
        >
          <Link to={"/disquaireday"} className="backHome" ref={backHomeRef}>
            <img src={backArrowIcon} alt="" />
          </Link>

          {!isSubscribed && (
            <>
              {/* {pageData?.wording_selection_2025 && (
                <div className="lotPhrase">
                  <RichText
                    className="lotPhrase"
                    render={pageData.wording_selection_2025}
                  />
                </div>
              )} */}
              {pageData?.wordingpreform && (
                <div
                  style={{
                    color: globalData.maintextcolor,
                  }}
                  className="lotPhrase"
                >
                  <RichText
                    className="lotPhrase"
                    render={pageData.wordingpreform}
                  />
                </div>
              )}
              {pageData?.dotapicture?.url && (
                <div className="boxPresentation">
                  <img src={pageData.dotapicture.url} alt="" />
                </div>
              )}

              <div className="contentContainer" ref={contentContainerRef}>
                <div id="formulaire"></div>
              </div>
            </>
          )}

          {isSubscribed && (
            <>
              <DisquairePage globalData={globalData} pageData={pageData} />
            </>
          )}

          <Footer globalData={globalData} />
        </main>
      </>
    );
  }
};

export default ArtistPage;
